import { StorageKeyEssentialEnum } from '@core/storage/types'

/**
 * Session storage key to store Soft PIP player state for later re-creation
 * Note: In some cases this key is used as string instead of imported as enum.
 */
export const SOFT_PIP_PLAYER_STATE_KEY = StorageKeyEssentialEnum.fw_ply_sft_pip

// Storage keys used by PIP feature

/** Session storage key to restore PIP iframe scroll position */
export const PIP_IFRAME_SCROLL_POSITION_KEY =
  StorageKeyEssentialEnum.fw_ply_scrll

/** Set when the user closes the pip, used to remember not to open pip again after reload in pinned mode */
export const PIP_DELIBERATELY_CLOSED_KEY =
  StorageKeyEssentialEnum.fw_ply_pipexit

/** Check whether PIP iframe is possible (stored in local storage) */
export const ABLE_TO_IFRAMEIZE_KEY = StorageKeyEssentialEnum.fw_ply_amnmze
